import { createLifeomicActionTypes } from '../../util/createActionTypes';

const asyncActionTypes = createLifeomicActionTypes(['LOAD_CONFIG']);

export default {
  ...asyncActionTypes,
};
